<app-navbar></app-navbar>
<!-- <app-spinner-loading></app-spinner-loading> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
